import axios from "axios";
import config from "config";

function getAuthToken(): string | undefined {
  if (typeof document === "undefined") return undefined;
  const match = document.cookie.match(/(?:^|; )subs-partner%3Aauth%3Atoken=([^;]*)/); // encoded-uri
  return match ? decodeURIComponent(match[1]) : undefined;
}

export const assetClient = axios.create({
  baseURL: config.asset.uri,
});

assetClient.interceptors.request.use((req) => {
  const token = getAuthToken();
  if (token) {
    req.headers.authorization = token;
  }
  req.headers["subs-client"] = config.apollo.name;
  return req;
});
